{
  "version": 1,
  "asset_id": "fdbb0bd2-29dc-4228-a07d-2b680e051b5d",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/fdbb0bd2-29dc-4228-a07d-2b680e051b5d/house-wash-100-off-poster.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/fdbb0bd2-29dc-4228-a07d-2b680e051b5d/house-wash-100-off-poster.webp",
  "original_filename": "house-wash-100-off-poster.webp",
  "size": 77608,
  "content_type": "image/webp",
  "created_at": "2026-08-01T22:43:51Z"
}
